import SmoothScrollAnchors from './src/scripts/smooth-scroll-anchors'

const onRouteUpdate = () => {
  // SmoothScrollAnchors()
}

export { onRouteUpdate }
